import getMobileOS from '../data/getMobileOS'

export default platform => () => {
  const os = getMobileOS()
  if (platform === 'Android') {
    if (os === 'Android') {
      window.location.href = process.env.REACT_APP_PLAY_STORE_URL
    } else {
      window.open(process.env.REACT_APP_PLAY_STORE_URL, '_blank', 'noopener')
    }
  } else if (platform === 'iOS') {
    if (os === 'iOS') {
      window.location.href = process.env.REACT_APP_APP_STORE_URL
    } else {
      window.open(process.env.REACT_APP_APP_STORE_URL, '_blank', 'noopener')
    }
  }
}
